import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest, call, put } from 'redux-saga/effects';
import { finishLoading, startLoading } from '../loading';
import * as projectApi from '../../lib/api/project';
import * as chanceApi from '../../lib/api/chance';

const [VIEW_PROJECT, VIEW_PROJECT_SUCCESS, VIEW_PROJECT_FAILURE] =
  createRequestActionTypes('project/VIEW_PROJECT');
export const viewProject = createAction(VIEW_PROJECT, (id) => id);
//const viewProjectSaga = createRequestSaga(VIEW_PROJECT, projectApi.getProject);

//활성화된 견적서 확인
const [
  PROJECT_ESTIMATE_ACTIVE,
  PROJECT_ESTIMATE_ACTIVE_SUCCESS,
  PROJECT_ESTIMATE_ACTIVE_FAILURE,
] = createRequestActionTypes('project/PROJECT_ESTIMATE_ACTIVE');
export const projectEstimateActive = createAction(
  PROJECT_ESTIMATE_ACTIVE,
  (id) => id,
);
const projectEstimateActiveSaga = createRequestSaga(
  PROJECT_ESTIMATE_ACTIVE,
  chanceApi.getActiveEstimate,
);

const [
  PROJECT_ORDER_COUNT,
  PROJECT_ORDER_COUNT_SUCCESS,
  PROJECT_ORDER_COUNT_FAILURE,
] = createRequestActionTypes('project/PROJECT_ORDER_COUNT');
export const projectOrderCount = createAction(PROJECT_ORDER_COUNT, (id) => id);
const projectOrderCountSaga = createRequestSaga(
  PROJECT_ORDER_COUNT,
  projectApi.getProjectOrderCount,
);

function* viewProjectSaga(action) {
  yield put(startLoading(VIEW_PROJECT));

  try {
    //project정보 가져오기
    const projectRes = yield call(projectApi.getProject, action.payload);
    const orderCountRes = yield call(
      projectApi.getProjectOrderCount,
      action.payload,
    );

    const project = projectRes.data.info;
    project.cmpStatus =
      project.cmpGrade === '0' || project.cmpGrade === null
        ? '수주품의'
        : project.cmpStatus;

    yield put({
      type: VIEW_PROJECT_SUCCESS,
      payload: {
        project: project,
        ordCount: orderCountRes.data.count,
        ordInfo: orderCountRes.data.list,
      },
    });

    //project의 수주 Count 가져오기
  } catch (e) {
    yield put({
      type: VIEW_PROJECT_FAILURE,
      payload: e,
      error: true,
    });
  }

  yield put(finishLoading(VIEW_PROJECT));
}

const UNLOAD_PROJECT = 'project/UNLOAD_PROJECT';
export const unloadProject = createAction(UNLOAD_PROJECT);

const SET_PROJECT = 'project/SET_PROJECT';
export const setProject = createAction(SET_PROJECT, (project) => project);

const SET_ORDER_COUNT = 'project/SET_ORDER_COUNT';
export const setOrderCount = createAction(SET_ORDER_COUNT, (data) => data);

export function* projectSaga() {
  yield takeLatest(VIEW_PROJECT, viewProjectSaga);
  yield takeLatest(PROJECT_ESTIMATE_ACTIVE, projectEstimateActiveSaga);
  yield takeLatest(PROJECT_ORDER_COUNT, projectOrderCountSaga);
}

const initialState = {
  project: null,
  activeEstimate: null,
  orderCount: null,
  orderInfo: null,
  error: null,
};

const project = handleActions(
  {
    [VIEW_PROJECT_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      project: data.project,
      orderCount: data.orderCount,
      orderInfo: data.orderInfo,
    }),
    [VIEW_PROJECT_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [PROJECT_ESTIMATE_ACTIVE_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      activeEstimate: data.info,
    }),
    [PROJECT_ESTIMATE_ACTIVE_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [PROJECT_ORDER_COUNT_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      orderCount: data.count,
      orderInfo: data.list,
    }),
    [PROJECT_ORDER_COUNT_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),

    [SET_ORDER_COUNT]: (state, { payload: data }) => ({
      ...state,
      orderCount: data.count,
      orderInfo: data.list,
    }),

    [SET_PROJECT]: (state, { payload: project }) => ({
      ...state,
      project: project,
    }),
    [UNLOAD_PROJECT]: () => initialState,
  },
  initialState,
);

export default project;
